import React from 'react'
import { useRouter } from 'next/router'
import ServiceSearchBarContent from './services-searchbar/ServiceSearchBarContent'
import StickyNavbar from 'components/StickyNavbar'
import MobileServiceSearchControls from './services-searchbar/MobileServiceSearchControls'
import { MobileScreenWidths, useScreenWidth } from 'data/hooks/useScreenWidth'
import { useFormContext } from 'react-hook-form'
import { DashboardSearchFormFields } from 'data/types/home/search'

interface ServicePageSearchBarProps {
  fixed?: boolean
  displayMobile?: boolean
}

const ServicePageSearchBar = ({
  fixed = false,
  displayMobile = true,
}: ServicePageSearchBarProps) => {
  const router = useRouter()
  const { isMobile } = useScreenWidth(MobileScreenWidths.LG)
  const { watch } = useFormContext<DashboardSearchFormFields>()

  if (isMobile) {
    return displayMobile
      ? (<MobileServiceSearchControls />)
      : <></>
  }

  return (
    <StickyNavbar
      fixed={fixed}
    >
      <ServiceSearchBarContent
        searchAction={() => router.push({
          pathname: '/services/all',
          query: {
            searchTerm: watch('search'),
            region: watch('destination.region.slug'),
            categories: watch('categories'),
            subcategories: watch('subCategories'),
            filters: watch('serviceFilters'),
          },
        })}
      />
    </StickyNavbar>
  )

}

export default ServicePageSearchBar
